import React, { useEffect, useRef, useState } from "react";
import ReactMapboxGl from "react-mapbox-gl";
import mapboxgl from "mapbox-gl";
import { MapViewProps } from "./MapAddress-types";

const Map = ReactMapboxGl({ accessToken: "" });

mapboxgl.setRTLTextPlugin(
  "https://cdn.parsimap.ir/third-party/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js",
  null
);

function getCurrentLocationWeb(onSuccess) {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(onSuccess);
  }
}

export default function MapViewComponent(props: MapViewProps) {
  let mapRef = useRef();
  let [zoom, setZoom] = useState(12);

  useEffect(() => {
    async function getCurrentLocation() {
      getCurrentLocationWeb((position) => {
        let region = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          latitudeDelta: 0.01,
          longitudeDelta: 0.01,
        };
        props.onChangeRegion(region);
        setZoom(15);
      });
    }

    getCurrentLocation();
    props.onReady();
  }, []);

  let center = [
    props.region?.longitude || props.defaultRegion.longitude,
    props.region?.latitude || props.defaultRegion.latitude,
  ];

  return (
    <Map
      ref={mapRef}
      zoom={[zoom]}
      center={center}
      style="https://api.parsimap.ir/styles/streets-v11?key=p1fe12ae4ee8f24a2cbc53bbadd72242712f830991"
      containerStyle={{ height: "100vh", width: "100vw" }}
      onDragEnd={(map) => {
        let { lng, lat } = map.getCenter();
        setZoom(map.getZoom().toFixed(2));
        props.onChangeRegion({
          ...props.defaultRegion,
          latitude: lat,
          longitude: lng,
        });
      }}
    />
  );
}
